import React from "react";
import { useLocale } from "../../contexts/LocaleProvider";

const styles = {
  wrapper: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "32px 20px",
    textAlign: "center",
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  iconWrap: {
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    backgroundColor: "#f2f2f2",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "16px",
  },
  text: {
    color: "#8a8a8a",
    fontSize: "14px",
    margin: 0,
  },
};

export default function EmptyChatState() {
  const { t } = useLocale();

  return (
    <div style={styles.wrapper}>
      <div style={styles.iconWrap}>
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z"
            stroke="#b0b0b0"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18 9h1a2 2 0 0 1 2 2v10l-4-4h-6a2 2 0 0 1-2-2v-1"
            stroke="#b0b0b0"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <p style={styles.text}>{t("sessionList.no_chat_found")}</p>
    </div>
  );
}